import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Question } from '../../App.styles';
import { Button, NavFooter } from '../../components';
import Result from '../../components/Result/Result';
import { ModelBrand, ResultInfo } from '../../components/Result/Result.styles';
import { useMetrics } from '../../hooks';
import { StepKey } from '../../types';
import { imagesUrl, metricEvents, MetricProperty, TestId } from '../../utils';
import getConfig, { VariantType } from '../shared/notCompatibleConfig';

interface BetaSupportProps {
  brand: string;
  model: string;
}

const BetaSupport: FunctionComponent<BetaSupportProps> = ({ brand, model }) => {
  const { track } = useMetrics();
  const { t } = useTranslation('common');
  const config = getConfig(VariantType.BETA_SUPPORT);

  return (
    <Result
      image={{
        source: imagesUrl.success_audio,
        altText: t('images.notCompatible'),
        cssClasses: 'w-100 h-100 object-fit-cover',
      }}
      stepKey={StepKey.NotCompatibleBetaSupport}
    >
      <div className="row h-100 flex-column" data-testid={TestId.BetaSupport}>
        <div className="flex-grow-1">
          <div className="mt-2 mt-md-4">{config.headerIcon.ring}</div>

          <Question className="my-3">{t(config.headerTitle)}</Question>

          <ResultInfo>
            <span>
              {t(config.description)}
              <span>
                :
                <ModelBrand>
                  {brand}, {model}.
                </ModelBrand>
              </span>
            </span>
          </ResultInfo>

          <ResultInfo>
            <span> {t(config.getNotified.description)}</span>
          </ResultInfo>
        </div>

        <NavFooter>
          <Button
            type="button"
            className="w-100"
            onClick={() => {
              track(metricEvents.betaSupportOptedIn, {
                [MetricProperty.betaSupportOptedIn]: true,
                brand,
                model,
              });
              window.open(
                `${t('results.homeUrl')}${t(
                  'results.notCompatible.getNotified.betaSupport.csSupportArticlePath'
                )}`,
                '_blank',
                'noopener,noreferrer'
              );
            }}
          >
            {t(config.getNotified.optInBtn)}
          </Button>
        </NavFooter>
      </div>
    </Result>
  );
};

export default BetaSupport;
